var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tbody',[_vm._l((_vm.items),function(item,index){return [_vm._t("default",null,{"item":item,"index":index})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }